import React from 'react';
import { FBProvider, FBSchemaComponentProps } from '..';
import { FBDeferredRenderProvider } from '../FBDeferredRender/FBDeferredRender.context';
import { withFBSchema } from './FBSchema.wrap';

const FBSchema: React.FunctionComponent<FBSchemaComponentProps> = ({
  schemaState,
  children,
}) => {
  return (
    <FBProvider {...{ schemaState }}>
      <FBDeferredRenderProvider>
        {children}
      </FBDeferredRenderProvider>
    </FBProvider>
  );
};

export default withFBSchema(FBSchema);
